<template>
  <CardWithDotsMenu
    v-hover
    class="section"
    :depth="depth"
    @remove-click="
      $emit('l-splice', { path: ['config', section.parent], index: index })
    "
  >
    <DynamicInputRenderer
      v-for="(input, index2) in section.inputs"
      :key="'input-arr-' + index2"
      :block="block"
      :input="input"
      :parent="parent"
      @l-change="
        $emit('deep-change', { path: [input.property], value: $event })
      "
      :pathprefix="[...pathprefix, index]"
    >
      <div
        v-for="(section2, index3) in input.subSections"
        :key="'sec2' + index3"
      >
        <draggable
          tag="div"
          :list="parent[section2.parent]"
          :handle="'.handle-depth-' + (depth + 1)"
          @end="saveBlockConfig(block)"
          ghostClass="ghost"
        >
          <WrappedDynamicInput
            v-for="(input2, index4) in parent[section2.parent]"
            :key="'wr-arr-' + index4"
            :block="block"
            :section="section2"
            :parent="input2"
            :index="index4"
            :items="parent[section2.parent]"
            :pathprefix="[...pathprefix, index]"
            @deep-change="
              $emit('deep-change', {
                path: [section2.parent, index4, ...$event.path],
                value: $event.value,
              })
            "
            @l-splice="
              $emit('l-splice', {
                path: ['config', section.parent, index, section2.parent],
                index: $event,
              })
            "
            :depth="depth + 1"
          ></WrappedDynamicInput>
        </draggable>
        <v-btn
          @click="addNewArrayItem(section2)"
          v-if="input.subSections"
          small
          >{{ section2.newItemButtonText }}</v-btn
        >
      </div>
    </DynamicInputRenderer>
  </CardWithDotsMenu>
</template>

<script>
import projectMixin from "../project-mixin";
import CardWithDotsMenu from "./CardWithDotsMenu";
import DynamicInputRenderer from "./DynamicInputRenderer";
import WrappedDynamicInput from "./WrappedDynamicInput";

export default {
  props: [
    "block",
    "section",
    "parent",
    "index",
    "items",
    "pathprefix",
    "depth",
  ],
  name: "WrappedDynamicInput",
  components: {
    CardWithDotsMenu,
    DynamicInputRenderer,
    WrappedDynamicInput,
  },
  mixins: [projectMixin],
  methods: {
    addNewArrayItem(section2) {
      const clonedNewItem = JSON.parse(JSON.stringify(section2.newItem));
      this.$emit("l-add-new", { item: clonedNewItem, path: [section2.parent] });
    },
  },
};
</script>